module.exports = __webpack_public_path__ + "img/int7_ros_rel_02.3c06875b.jpg";